var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (action, button_class, call) {
buf.push("<div class=\"LoggedOutCTA\"><span class=\"Type Type--size-lg\">" + (jade.escape(null == (jade_interp = call) ? "" : jade_interp)) + "</span><div class=\"LoggedOutCTA__buttons\"><a href=\"/sign_up?ref=logged_out_cta\"" + (jade.cls(['Button','Button--size-sm','js-sign_up',button_class], [null,null,null,true])) + ">Sign up</a>");
if (!( action === 'explore'))
{
buf.push("<a href=\"/explore?ref=logged_out_cta\" class=\"Button Button--size-sm\">Explore</a>");
}
buf.push("</div></div>");}.call(this,"action" in locals_for_with?locals_for_with.action:typeof action!=="undefined"?action:undefined,"button_class" in locals_for_with?locals_for_with.button_class:typeof button_class!=="undefined"?button_class:undefined,"call" in locals_for_with?locals_for_with.call:typeof call!=="undefined"?call:undefined));;return buf.join("");
};
module.exports = template;